import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { FolderCheck } from "lucide-react";
import { api } from "@/lib/api";

export function BulkDosyaDurumu({ ids, onDone }) {
  const [opts, setOpts] = useState(["İNFAZ", "KISMİ ÖDEME"]);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api.get("/field-templates/dosya_durumu").then((r) => {
      const l = (r.data.rows || []).map((x) => x.ad);
      if (l.length) setOpts(l);
    }).catch(() => {});
  }, []);

  const apply = async (v) => {
    if (v === null) return;
    const label = v || "boş";
    if (!window.confirm(`Seçili ${ids.length} tahsilatın Dosya Durumu "${label}" yapılsın mı?`)) return;
    setBusy(true);
    try {
      const r = await api.post("/tahsilat/bulk-dosya-durumu", { ids, dosya_durumu: v });
      toast.success(`${r.data.updated} kayıt güncellendi · ${label}`);
      onDone?.();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Toplu güncelleme başarısız");
    } finally { setBusy(false); }
  };

  return (
    <label className="inline-flex items-center gap-1.5 bg-teal-600 hover:bg-teal-700 text-white text-xs font-semibold pl-3 pr-1 py-1 rounded-md" title="Seçili satırlara Dosya Durumu ata">
      <FolderCheck size={14} /> D. Durumu
      <select value="" disabled={busy} onChange={(e) => apply(e.target.value === "__clear" ? "" : e.target.value)}
        data-testid="tahsilat-bulk-dosya-durumu" className="bg-white text-teal-800 rounded px-1 py-1 text-xs font-semibold outline-none">
        <option value="" disabled>Seç ({ids.length})</option>
        {opts.map((o) => <option key={o} value={o}>{o}</option>)}
        <option value="__clear">— Temizle —</option>
      </select>
    </label>
  );
}
